import { render, staticRenderFns } from "./DynamicMediaField.vue?vue&type=template&id=68489f6e&scoped=true&"
import script from "./DynamicMediaField.vue?vue&type=script&lang=js&"
export * from "./DynamicMediaField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicMediaField.vue?vue&type=style&index=0&id=68489f6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68489f6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VFileInput,VIcon,VTextField})
